var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.01 58.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d1d1b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.3,38.92c-1.07-1.07-1.63-2.65-1.95-5a88.48,88.48,0,0,1-.46-9.51A88.48,88.48,0,0,1,16.43,34c-.32,2.32-.89,3.9-2,5s-2.64,1.64-5,1.95a88.27,88.27,0,0,1-9.5.46,91,91,0,0,1,9.5.46c2.33.32,3.9.89,5,2s1.64,2.64,2,5a88.42,88.42,0,0,1,.46,9.5,88.42,88.42,0,0,1,.46-9.5c.32-2.33.88-3.9,1.95-5s2.65-1.64,5-2,32.41-.38,36.5-.46c-4.09-.07-34.18-.14-36.5-.46S20.37,40,19.3,38.92ZM61.5,16.43c-2.32-.32-3.9-.89-5-2s-1.63-2.64-2-5A88.27,88.27,0,0,1,54.12,0a88.27,88.27,0,0,1-.46,9.5c-.32,2.33-.89,3.9-2,5s-2.64,1.64-5,2-32.41.39-36.5.46c4.09.07,34.17.14,36.5.46s3.9.88,5,1.95,1.64,2.65,2,5a88.27,88.27,0,0,1,.46,9.5,88.27,88.27,0,0,1,.46-9.5c.32-2.33.88-3.91,2-5s2.65-1.63,5-1.95A88.63,88.63,0,0,1,71,16.89,88.63,88.63,0,0,1,61.5,16.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector20);
export default __webpack_public_path__ + "static/media/VECTOR_20.39bc11ad70e949b4912569610d2d5a65.svg";
export { ForwardRef as ReactComponent };